var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _rect3, _rect4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect5, _rect6, _rect7, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _rect8, _rect9, _rect10, _rect11, _circle, _rect12, _rect13, _path59, _path60, _path61, _path62, _path63, _path64, _rect14, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongelador(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 917,
    viewBox: "0 0 454 917",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H358C363.523 0 368 4.47715 368 10V897H0V10Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14C4 8.47715 8.47715 4 14 4H354C359.523 4 364 8.47715 364 14V893H4V14Z",
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14C4 8.47715 8.47715 4 14 4H354C359.523 4 364 8.47715 364 14V130H4V14Z",
    fill: "#95C6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 165H323V242H45V165Z",
    fill: "#EDEDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 289H323V364H45.002L45 289Z",
    fill: "#CBE6EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 165H322V240H45.002L45 165Z",
    fill: "#CBE7EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 410H324V491H46V410Z",
    fill: "#CBE6EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 547,
    width: 280,
    height: 110,
    fill: "#EDECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 547,
    width: 280,
    height: 110,
    fill: "#CBE6EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M428 692H454V917H428V692Z",
    fill: "#909090"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425 88H443V683H425V88Z",
    fill: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 694,
    width: 18,
    height: 214,
    fill: "#C0C0C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 95,
    width: 11,
    height: 584,
    fill: "#C0C0C0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M416.45 707.543L420.5 706.899V711V893V898.157L415.708 896.253L377.708 881.153L375.5 880.276V877.901V717.047V714.06L378.45 713.591L416.45 707.543Z",
    fill: "#B5E8BC",
    fillOpacity: 0.1,
    stroke: "#909090",
    strokeWidth: 7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M412.1 114.061L417.513 110.562L417.5 117.007L416.393 668.213L416.386 671.503L413.103 671.7L383.21 673.494L379.5 673.716V670V137.037V135.132L381.1 134.098L412.1 114.061Z",
    fill: "#B5E8BC",
    fillOpacity: 0.1,
    stroke: "#909090",
    strokeWidth: 7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M416.607 708.531L419.5 708.071V711V893V896.684L416.077 895.323L378.077 880.224L376.5 879.598V877.901V717.047V714.914L378.607 714.578L416.607 708.531Z",
    fill: "#BBD5EC",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M412.643 114.9L416.537 112.383L416.5 117.02L412.071 668.226L412.053 670.544L409.74 670.701L383.168 672.494L380.5 672.674V670V137.037V135.676L381.643 134.938L412.643 114.9Z",
    fill: "#B5E8BC",
    fillOpacity: 0.1,
    stroke: "white",
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 130L20 143.221V858.542L4 877V130Z",
    fill: "#C0C0C0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1073 657H323.595L339 690H21L44.1073 657Z",
    fill: "#D5E0FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 491H322.5L339 518H20L45.3 491Z",
    fill: "#D5E0FB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 364H322.5L339 390H20L45.3 364Z",
    fill: "#D5E1FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 242H322.5L339 269H20L45.3 242Z",
    fill: "#D5E0FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.105 242H323.299L324 245H44L45.105 242Z",
    fill: "#C4C4C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.105 491H323.299L324 493H44L45.105 491Z",
    fill: "#C4C4C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.105 363H322.299L323 364H43L44.105 363Z",
    fill: "#C4C4C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5467 657H325V659H42L43.5467 657Z",
    fill: "#C4C4C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5467 657H325V659H42L43.5467 657Z",
    fill: "#C4C4C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5464 547H324.939L326 544H42L43.5464 547Z",
    fill: "#C4C4C4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5464 547H324.939L326 544H42L43.5464 547Z",
    fill: "#C4C4C4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5246 412H322.954L324 410H44L45.5246 412Z",
    fill: "#C4C4C4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5246 291H322.954L324 289H44L45.5246 291Z",
    fill: "#C4C4C4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5246 167H322.954L324 165H44L45.5246 167Z",
    fill: "#C4C4C4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5085 143H339.631L364 130H4L19.5085 143Z",
    fill: "#C0C0C0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1799 522H323.547L339 540H20L43.1799 522Z",
    fill: "#CBC0C0",
    fillOpacity: 0.68
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 518,
    width: 319,
    height: 22,
    fill: "#767676"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 390,
    width: 319,
    height: 16,
    fill: "#767676"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 269,
    width: 319,
    height: 15,
    fill: "#767676"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42 551L44 553.205V657.898L43 659L42 656.796V551Z",
    fill: "#C4C4C4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42 544L44 546.348V657.827L43 659L42 656.653V544Z",
    fill: "#C4C4C4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M326 551L324 553.205V656.796V659L326 656.796V551Z",
    fill: "#C4C4C4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M326 544L324 546.348V656.653V659L326 656.653V544Z",
    fill: "#C4C4C4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0806 655.836L43.8686 657.088L20.9371 689.815L19.8492 689.826L19.8351 687.611L42.0806 655.836Z",
    fill: "#C4C4C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0806 655.836L43.8686 657.088L20.9371 689.815L19.8492 689.826L19.8351 687.611L42.0806 655.836Z",
    fill: "#C4C4C4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M323.971 657.681L326.175 656.757L339.398 685.408L339.398 689.816L323.971 657.681Z",
    fill: "#C4C4C4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M323.971 657.681L326.175 656.757L339.398 685.408L339.398 689.816L323.971 657.681Z",
    fill: "#C4C4C4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M337.194 539.951L339.4 539.951L339.398 543.257L325.103 546.794L324.359 544.719L337.194 539.951Z",
    fill: "#C4C4C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8349 542.156L19.8363 539.952L24.2427 539.952L44.0195 545.019L43.4382 547.145L19.8349 542.156Z",
    fill: "#C4C4C4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44 410L46 411.691V492.849L45 494L44 493.467V410Z",
    fill: "#C4C4C4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44 289L46 290.51V362.973L45 364L44 363.524V289Z",
    fill: "#C4C4C4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44 165L46 166.55V242H45H44V165Z",
    fill: "#C4C4C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M324 410L322 411.654V489.347V491L324 490.999V410Z",
    fill: "#C4C4C4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M324 289L322 290.531V362.469V364L324 364V289Z",
    fill: "#C4C4C4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M324 165L322 166.633V243.367V245L324 245V165Z",
    fill: "#C4C4C4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4137 489.655L46.262 491.49L22.757 517.883L19.8365 517.913L19.835 515.709L45.4137 489.655Z",
    fill: "#C4C4C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5615 362.077L46.2818 363.64L23.141 390.087L20.9371 390.087L19.8352 390.087L19.8284 387.205L44.5615 362.077Z",
    fill: "#C4C4C4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5107 241.558L47.3203 242.985L24.3717 269.535L21.0348 269.232L20.2311 269.162L19.6613 265.55L44.5107 241.558Z",
    fill: "#C4C4C4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M321.766 492.573L323.967 491.466L339.398 515.709L339.397 517.913L336.091 517.913L321.766 492.573Z",
    fill: "#C4C4C4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M321.149 363.798L323.351 362.691L339.397 386.78L339.397 390.086L334.989 390.086L321.149 363.798Z",
    fill: "#C4C4C4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M321.506 243.936L323.707 242.829L339.397 264.465L339.397 268.872L334.99 268.873L321.506 243.936Z",
    fill: "#C4C4C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M336.091 405.514L339.399 405.514L339.398 408.82L321.175 412.236L320.171 410.626L336.091 405.514Z",
    fill: "#C4C4C4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M336.092 284.299L339.4 284.299L339.398 287.605L323.12 290.79L322.115 289.181L336.092 284.299Z",
    fill: "#C4C4C4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M336.039 143.327L339.398 143.253L339.216 147.898L322.889 166.821L321.138 166.091L336.039 143.327Z",
    fill: "#C4C4C4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 407.718L19.8373 405.515L23.141 405.514L46.2818 409.922L44.7512 412.208L19.833 407.718Z",
    fill: "#C4C4C4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 286.506L19.8348 284.302L22.0369 284.302L46.2815 288.71L45.1796 290.914L19.8332 286.506Z",
    fill: "#C4C4C4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8337 146.559L19.834 143.254L24.2443 143.253L46.2818 165.292L44.0779 167.496L19.8337 146.559Z",
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 126,
    width: 366,
    height: 4,
    fill: "#585858"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 137,
    width: 4,
    height: 559,
    fill: "#585858"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 439,
    y: 785,
    width: 6,
    height: 39,
    fill: "#767676"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 423,
    width: 7,
    height: 51,
    fill: "#767676"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 62,
    r: 44,
    fill: "#CBE6EF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 716,
    width: 280,
    height: 110,
    fill: "#EDECEC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 716,
    width: 280,
    height: 110,
    fill: "#CBE6EF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1073 826H322.595L338 860H20L43.1073 826Z",
    fill: "#D5E0FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5467 826H324V829H41L42.5467 826Z",
    fill: "#C4C4C4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5467 826H324V829H41L42.5467 826Z",
    fill: "#C4C4C4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5464 716H323.939L325 714H41L42.5464 716Z",
    fill: "#C4C4C4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5464 716H323.939L325 714H41L42.5464 716Z",
    fill: "#C4C4C4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1799 692H322.547L338 710H19L42.1799 692Z",
    fill: "#CBC0C0",
    fillOpacity: 0.68
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 688,
    width: 319,
    height: 22,
    fill: "#767676"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M41 721L43 723.205V827.898L42 829L41 826.796V721Z",
    fill: "#C4C4C4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41 714L43 716.348V827.827L42 829L41 826.653V714Z",
    fill: "#C4C4C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M325 721L323 723.205V826.796V829L325 826.796V721Z",
    fill: "#C4C4C4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M325 714L323 716.348V826.653V829L325 826.653V714Z",
    fill: "#C4C4C4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9141 825.535L42.7021 826.787L19.7706 859.515L18.6827 859.526L18.6686 857.311L40.9141 825.535Z",
    fill: "#C4C4C4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9141 825.535L42.7021 826.787L19.7706 859.515L18.6827 859.526L18.6686 857.311L40.9141 825.535Z",
    fill: "#C4C4C4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M322.804 827.38L325.008 826.457L338.231 855.107L338.231 859.515L322.804 827.38Z",
    fill: "#C4C4C4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M322.804 827.38L325.008 826.457L338.231 855.107L338.231 859.515L322.804 827.38Z",
    fill: "#C4C4C4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M336.028 709.65L338.233 709.65L338.232 712.957L323.936 716.493L323.192 714.418L336.028 709.65Z",
    fill: "#C4C4C4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6684 711.854L18.6698 709.65L23.0762 709.65L42.8529 714.718L42.2717 716.843L18.6684 711.854Z",
    fill: "#C4C4C4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6182 860H338.601L364 873.2V893H4V877.6L18.6182 860Z",
    fill: "#C0C0C0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M364 130L338.174 143.209L337 860.851L364 884V130Z",
    fill: "#C0C0C0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongelador);
export default __webpack_public_path__ + "static/media/Congelador.047837b5f37a0351dde909eb35c2ec7f.svg";
export { ForwardRef as ReactComponent };